import request from '@/config/axios'

// 酒店
export const getScenicHotelPage = (params: any) => {
  return request.get({ url: '/scenic/hotel/page', params })
}

export const getScenicHotel = (id: number) => {
  return request.get({ url: '/scenic/hotel/get', params: { id } })
}

export const createScenicHotel = (data: any) => {
  return request.post({ url: '/scenic/hotel/create', data })
}

export const updateScenicHotel = (data: any) => {
  return request.put({ url: '/scenic/hotel/update', data })
}

export const deleteScenicHotel = (id: number) => {
  return request.delete({ url: '/scenic/hotel/delete', params: { id } })
}

export const deleteScenicHotelList = (ids: number[]) => {
  return request.delete({ url: '/scenic/hotel/delete-list', params: { ids: ids.join(',') } })
}

export const exportScenicHotelExcel = (params: any) => {
  return request.download({ url: '/scenic/hotel/export-excel', params })
}
